import moment from 'moment';

import { Timestamp } from './graphqlTypes/customScalarTypes';

export const getDaysRemainingOnTrial = (trialExpiresAt: Timestamp['output']) =>
  moment(trialExpiresAt).endOf('date').diff(moment().startOf('date'), 'days');
